import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_validate_create_sales_order_request_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { order: { owner?: string, project?: string, owner_reference?: string, vendor_reference?: string, requested_delivery_date?: string, notes?: string, warehouse?: string, carrier?: string, carrier_service_type?: string, order_lines?: any, addresses?: any, custom_fields?: any } }): Promise<void> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.order)) {
      missingRequiredInParams.push('\'order\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

